module.exports = __webpack_public_path__ + "static/img/kefu.75e907a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/kefu.jpg
// module id = VuJk
// module chunks = 1